const GetUrlTicketPath = () => {
	const url = window.location.href;
	const partesDaURL = url.split('/');
	return partesDaURL[partesDaURL.length - 1];
}

export default GetUrlTicketPath;